module.exports = __webpack_public_path__ + "static/media/win.31244967.png";